export const COUNTRIES = [
    { iso: 'US', name: 'United States', dial: '+1', flag: '🇺🇸', min: 10, max: 10 },
    { iso: 'CA', name: 'Canada', dial: '+1', flag: '🇨🇦', min: 10, max: 10 },
    { iso: 'GB', name: 'United Kingdom', dial: '+44', flag: '🇬🇧', min: 10, max: 10 },
    { iso: 'IN', name: 'India', dial: '+91', flag: '🇮🇳', min: 10, max: 10 },
    { iso: 'AU', name: 'Australia', dial: '+61', flag: '🇦🇺', min: 9, max: 9 },
    { iso: 'DE', name: 'Germany', dial: '+49', flag: '🇩🇪', min: 10, max: 11 },
    { iso: 'FR', name: 'France', dial: '+33', flag: '🇫🇷', min: 9, max: 9 },
    { iso: 'ES', name: 'Spain', dial: '+34', flag: '🇪🇸', min: 9, max: 9 },
    { iso: 'IT', name: 'Italy', dial: '+39', flag: '🇮🇹', min: 9, max: 11 },
    { iso: 'NL', name: 'Netherlands', dial: '+31', flag: '🇳🇱', min: 9, max: 9 },
    { iso: 'IE', name: 'Ireland', dial: '+353', flag: '🇮🇪', min: 9, max: 9 },
    { iso: 'SE', name: 'Sweden', dial: '+46', flag: '🇸🇪', min: 7, max: 9 },
    { iso: 'NO', name: 'Norway', dial: '+47', flag: '🇳🇴', min: 8, max: 8 },
    { iso: 'DK', name: 'Denmark', dial: '+45', flag: '🇩🇰', min: 8, max: 8 },
    { iso: 'FI', name: 'Finland', dial: '+358', flag: '🇫🇮', min: 9, max: 10 },
    { iso: 'CH', name: 'Switzerland', dial: '+41', flag: '🇨🇭', min: 9, max: 9 },
    { iso: 'AT', name: 'Austria', dial: '+43', flag: '🇦🇹', min: 10, max: 11 },
    { iso: 'BE', name: 'Belgium', dial: '+32', flag: '🇧🇪', min: 8, max: 9 },
    { iso: 'PT', name: 'Portugal', dial: '+351', flag: '🇵🇹', min: 9, max: 9 },
    { iso: 'PL', name: 'Poland', dial: '+48', flag: '🇵🇱', min: 9, max: 9 },
    { iso: 'NZ', name: 'New Zealand', dial: '+64', flag: '🇳🇿', min: 8, max: 10 },
    { iso: 'AE', name: 'United Arab Emirates', dial: '+971', flag: '🇦🇪', min: 9, max: 9 },
    { iso: 'SA', name: 'Saudi Arabia', dial: '+966', flag: '🇸🇦', min: 9, max: 9 },
    { iso: 'SG', name: 'Singapore', dial: '+65', flag: '🇸🇬', min: 8, max: 8 },
    { iso: 'HK', name: 'Hong Kong', dial: '+852', flag: '🇭🇰', min: 8, max: 8 },
    { iso: 'JP', name: 'Japan', dial: '+81', flag: '🇯🇵', min: 10, max: 11 },
    { iso: 'KR', name: 'South Korea', dial: '+82', flag: '🇰🇷', min: 9, max: 10 },
    { iso: 'CN', name: 'China', dial: '+86', flag: '🇨🇳', min: 11, max: 11 },
    { iso: 'ZA', name: 'South Africa', dial: '+27', flag: '🇿🇦', min: 9, max: 9 },
    { iso: 'BR', name: 'Brazil', dial: '+55', flag: '🇧🇷', min: 10, max: 11 },
    { iso: 'MX', name: 'Mexico', dial: '+52', flag: '🇲🇽', min: 10, max: 10 },
    { iso: 'AR', name: 'Argentina', dial: '+54', flag: '🇦🇷', min: 10, max: 11 },
    { iso: 'ID', name: 'Indonesia', dial: '+62', flag: '🇮🇩', min: 9, max: 11 },
    { iso: 'MY', name: 'Malaysia', dial: '+60', flag: '🇲🇾', min: 9, max: 10 },
    { iso: 'PH', name: 'Philippines', dial: '+63', flag: '🇵🇭', min: 10, max: 10 },
    { iso: 'TH', name: 'Thailand', dial: '+66', flag: '🇹🇭', min: 9, max: 9 },
    { iso: 'VN', name: 'Vietnam', dial: '+84', flag: '🇻🇳', min: 9, max: 10 },
    { iso: 'EG', name: 'Egypt', dial: '+20', flag: '🇪🇬', min: 10, max: 10 },
    { iso: 'NG', name: 'Nigeria', dial: '+234', flag: '🇳🇬', min: 10, max: 10 },
    { iso: 'KE', name: 'Kenya', dial: '+254', flag: '🇰🇪', min: 9, max: 9 },
    { iso: 'IL', name: 'Israel', dial: '+972', flag: '🇮🇱', min: 9, max: 9 },
    { iso: 'TR', name: 'Türkiye', dial: '+90', flag: '🇹🇷', min: 10, max: 10 },
    { iso: 'RU', name: 'Russia', dial: '+7', flag: '🇷🇺', min: 10, max: 10 },
    { iso: 'UA', name: 'Ukraine', dial: '+380', flag: '🇺🇦', min: 9, max: 9 },
    { iso: 'XX', name: 'Other', dial: '+', flag: '🌐', min: 4, max: 15 },
];
export const DEFAULT_COUNTRY_ISO = 'US';
